



























import Modal from "buefy/src/components/modal/Modal.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ConfirmModalModes } from "@/data/enums";
import { BModalComponent } from "buefy/types/components";
import { IModalComponent } from "@/models/modal";

const BuefyModalComponent = Vue.extend(Modal);

@Component
export default class SlideModal extends BuefyModalComponent
  implements IModalComponent {
  // Props
  @Prop({ default: null })
  public modalHash!: string;

  // Data
  public areYouSureModal: BModalComponent | null = null;
  public blockCancellation = false;
  public keepModalOpen = false;

  // Lifecycle methods
  public created() {
    this.$store.commit("ui/setSlider", this.sliderObject);
  }

  public beforeDestroy() {
    this.$store.commit("ui/unsetSlider", this.sliderObject);
  }

  // Getters
  public get dynamicHeight(): string {
    return `${this.$store.state.ui.window.height}px`;
  }

  public get sliderObject() {
    return {
      id: this.$_.get(this, "_uid"),
      hash: this.modalHash || this.$_.get(this, "_uid")
    };
  }

  public get right() {
    const sliders = this.sliders.slice().reverse();
    const index = sliders.indexOf(this.sliderObject);
    const right = this.$_.get([0, 25, 50, 75], `[${index}]`, 100);
    return `${right}%`;
  }

  public get currentlyActive() {
    return this.$_.isEqual(this.$_.last(this.sliders), this.sliderObject);
  }

  public get sliders() {
    return this.$store.state.ui.sliders;
  }

  public get parentSlideModal() {
    return this.getParentModal(this);
  }

  // Methods
  public setBlockCancellation(val) {
    this.blockCancellation = val;
  }

  //override
  public close() {
    if (this.areYouSureModal) {
      return;
    }

    if (
      this.$_.isFunction(
        this.$_.get(BuefyModalComponent, "options.methods.close.call")
      )
    ) {
      // @ts-ignore
      BuefyModalComponent.options.methods.close.call(this);
    }
  }

  // override
  public cancel(method) {
    // This prevents all modals to close on ESC
    if (method === "escape" && !this.currentlyActive) {
      return;
    }

    this.areYouSureModal = null;

    if (
      this.blockCancellation ||
      // @ts-ignore
      this.$_.get(this, "cancelOptions", []).indexOf(method) < 0
    ) {
      if (this.blockCancellation) {
        this.$store
          .dispatch("ui/open/confirmModal", {
            config: {
              props: {
                closeButtonText: this.$t("_.no"),
                confirmButtonText: this.$t("_.yes"),
                mode: ConfirmModalModes.BUTTON,
                startProcessingAtConfirm: false,
                title: this.$t("_sentence.action_in_process"),
                message: this.$t(
                  "_sentence.are_you_sure_you_want_to_close_this_modal"
                )
              },
              events: {
                confirmed: () => {
                  this.areYouSureModal = null;
                  this.close();
                  // @ts-ignore
                  this.onCancel(method);
                },
                close: () => {
                  this.areYouSureModal?.close();
                  this.areYouSureModal = null;
                }
              }
            }
          })
          .then(modal => (this.areYouSureModal = modal));
      }
      return;
    }

    // @ts-ignore
    this.areYouSureModal && this.areYouSureModal.close();
    // @ts-ignore
    this.onCancel(method);
    this.close();
  }

  public getParentModal(vue) {
    if (!vue) {
      return null;
    }
    return ["BModal"].includes(this.$_.get(vue, "constructor.options.name"))
      ? vue
      : this.getParentModal(vue.$parent);
  }
}
